import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Buscás ejemplos de economía… y todo es urbano', 'Explicar costos o inflación sin casos reales del agro', 'Armás actividades desde cero cada semana', 'Evaluaciones improvisadas sin criterios claros', 'No hay conexión con la realidad de tus alumnos', 'Terminás improvisando'];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark" data-id="element-154">
      <div className="max-w-3xl mx-auto" data-id="element-155">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-6 text-white leading-tight" data-id="element-156">
          💣 ¿CUÁNTOS DOMINGOS MÁS VAS A PERDER ASÍ?
        </h2>

        <p className="text-sm md:text-base text-gray-400 mb-8 text-center max-w-2xl mx-auto leading-relaxed" data-id="element-157">
          Sos docente en una escuela técnica agropecuaria o rural. Enseñás
          economía, producción o gestión…
          <br data-id="element-158" />
          <br data-id="element-159" />
          <span className="text-white font-bold" data-id="element-160">
            Pero nadie te dio material pensado para el campo.
          </span>
        </p>

        <div className="bg-brand-card border-l-4 border-brand-accent p-5 md:p-6 rounded-r-lg mb-10" data-id="element-161">
          <div className="space-y-3" data-id="element-162">
            {points.map((point, index) => <div key={index} className="flex items-start" data-id="element-163">
                <XCircle className="w-5 h-5 text-red-500 mr-3 shrink-0 mt-0.5" data-id="element-164" />
                <p className="text-sm md:text-base text-gray-300 font-medium" data-id="element-165">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-166">
          <p className="text-lg md:text-xl font-bold text-brand-accent mb-2 neon-glow" data-id="element-167">
            👉 No es falta de vocación. Es falta de un sistema.
          </p>
        </div>

        <div className="text-center" data-id="element-168">
          <h3 className="text-xl md:text-3xl font-black text-white" data-id="element-169">
            💡 ¿Y SI ESTE FUERA EL ÚLTIMO DOMINGO ASÍ?
          </h3>
        </div>
      </div>
    </section>;
}